import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ReactComponent as ViticulturaIcon } from '../assets/icons/ViticulturaIcon.svg';
import { ReactComponent as EmbotelladoIcon } from '../assets/icons/EmbotelladoIcon.svg';
import { ReactComponent as VinificacionIcon } from '../assets/icons/VinificacionIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/react";
import { getAuth } from 'firebase/auth';
import LoadingSpinner from '../components/LoadingSpinner'
import FechaDateInput from './FechaDateInput';

// Lo que no se puede editar en cada etapa, y por qué. El backend descarta estos
// campos igual aunque lleguen (ver CAMPOS_BLOQUEADOS_TRAZABILIDAD en main.py).
const AVISO_BLOQUEADOS = {
  viticultura: 'Los quintales, la variedad, el área de cosecha, la fecha de cosecha y el tipo de propiedad no se editan: ya generaron stock y están dentro del ID del lote.',
  vinificacion: 'Los hectolitros, los quintales consumidos y el lote de origen no se editan: ya movieron stock y definen el rendimiento de la partida.',
  embotellado: 'Las partidas usadas no se editan: ya descontaron hectolitros de las partidas. La cantidad de botellas sí se puede editar (ajusta el stock de botellas/tapones y de vino sin etiquetar), pero sólo mientras no se haya etiquetado ninguna parte de esta tirada; si ya se etiquetó algo, el guardado la va a rechazar.',
};

export default function DocEdit() {
const { coleccion, id } = useParams();
const [message, setMessage] = useState(null);
const [progress, setProgress] = useState(0);
const [isLoading, setIsLoading] = useState(false);

const navigate = useNavigate();
const [formData, setFormData] = useState(null);
const [unidadVolumen, setUnidadVolumen] = useState('Hectolitros');
const provenienzaOptions = [
  { value: 'cuartel', label: 'Cuartel' },
  { value: 'hectarea', label: 'Hectárea' },
  { value: 'hilera', label: 'Hilera' },
  { value: 'parcela', label: 'Parcela' }
];
const opcionesRecipienteUso = ['Primero', 'Segundo', 'Tercero'];
const opcionesRecipienteTostado = ['Suave', 'Medio', 'Fuerte'];
const tiposDeRecipienteFermentacion = [
  'Acero Inoxidable',
  'Ánforas de barro',
  'Barrica de Roble Americano',
  'Barrica de Roble Francés',
  'Barrica otro',
  'Epoxi',
  'Fudres',
  'Hormigón',
  'Huevos de Hormigón'
];
const variedadesDeUva = [
'Albariño', 'Ancellotta', 'Bonarda', 'Cabernet Franc', 'Cabernet Sauvignon',
'Carmenère', 'Cereza', 'Chardonnay', 'Chenin Blanc', 'Criolla Grande',
'Garnacha', 'Malbec', 'Mencía', 'Merlot', 'Moscatel de Alejandría',
'Nebbiolo', 'Palomino', 'Pedro Giménez', 'Petit Verdot', 'Pinot Gris',
'Pinot Noir', 'Quebranta', 'Riesling', 'Sangiovese', 'Sauvignon Blanc',
'Semillón', 'Syrah', 'Tannat', 'Tempranillo', 'Torrontés',
'Touriga Nacional', 'Verdejo', 'Viognier', 'Zinfandel'
];
const tiposDeMedida = [
    'Piccolo (187,5 ml)',
    'Media Botella (375 ml)',
    'Estándar (750 ml)',
    'Magnum (1.5 L)',
    'Doble Magnum (3 L)',
    'Jeroboam (Vino) (4.5 L)',
    'Jeroboam (Champán) (3 L)',
    'Imperial (6 L)',
    'Salmanazar (9 L)',
    'Baltasar (12 L)',
    'Nabucodonosor (15 L)',
    'Salomón (18 L)',
    'Melchor (20 L)',
    'Souverain (26.25 L)',
    'Primat (27 L)'
];


useEffect(() => {
const cargarDocumento = async () => {
    const user = getAuth().currentUser;
    if (!user) return;
    const idToken = await user.getIdToken();
    const res = await fetch(`https://backend-288175208699.europe-west1.run.app/api/${coleccion}/${id}`, {
        headers: { Authorization: `Bearer ${idToken}` },
    });
    const data = await res.json();
    setFormData(data);
};
cargarDocumento();
}, [coleccion, id]);


if (!formData) return <p></p>;

if (coleccion === "embotellado" && !formData.partidas_usadas) {
return <LoadingSpinner/>;
}
const levaduraOptions = {
  'Fermentación Nativa': 'Fermentación Nativa',
  'No-Saccharomyces': [
    'Brettanomyces bruxellensis',
    'Hanseniaspora uvarum',
    'Kloeckera apiculata',
    'Lachancea thermotolerans',
    'Metschnikowia pulcherrima',
    'Pichia kluyveri',
    'Starmerella bacillaris',
    'Torulaspora delbrueckii',
  ],
  'Saccharomyces': [
    'Saccharomyces bayanus',
    'Saccharomyces cerevisiae',
    'Saccharomyces pastorianus',
    'Saccharomyces uvarum',
  ],
};

const tiposDeSuelo = [
'Arcillo arenoso',
'Arcillo limoso',
'Arcilloso',
'Arenoso',
'Calcáreo',
'Franco arenoso',
'Franco arcilloso',
'Franco calcáreo',
'Franco limoso',
'Limoso'
];
const tiposDeRiego = [
'Aspersión',
'Goteo',
'Manto',
'Surco'
];
const handleChange = (e) => {
const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
const handlePertenenciaChange = (e) => {
const value = e.target.value;
setFormData({
...formData,
pertenencia: value,
provenienza: value === "tercero" ? null : formData.provenienza,
nombre_finca: value === "propia" ? "" : formData.nombre_finca,
});
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setProgress(0);
  setMessage(null);

  const user = getAuth().currentUser;
  if (!user) {
    setMessage({ type: 'error', text: 'Debes iniciar sesión.' });
    setIsLoading(false);
    return;
  }

  try {
    const idToken = await user.getIdToken();

    // Simulamos progreso mientras dura la petición
    const interval = setInterval(() => {
      setProgress(prev => Math.min(prev + 5, 95)); // hasta 95%
    }, 100);

    const response = await fetch(`https://backend-288175208699.europe-west1.run.app/api/${coleccion}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${idToken}`,
      },
      body: JSON.stringify(formData),
    });

    clearInterval(interval);
    setProgress(100); // completamos al finalizar
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || 'Ocurrió un error al actualizar el documento.');
    }

    setMessage({ type: 'success', text: 'Documento actualizado exitosamente.' });
    setTimeout(() => {
      navigate(`/trazabilidad/${id}`);
    }, 800);

  } catch (error) {
    console.error("Error al actualizar el documento:", error);
    setMessage({ type: 'error', text: error.message });
    setIsLoading(false);
    setProgress(0);
  }
};
if (!formData) return <LoadingSpinner/>;

const renderForm = () => {
switch (coleccion) {
    case "viticultura":
    return (
    <div className="Trazabilidad">
        <header className="trazabilidad-header">
            <div className="header-content">
                <h1>Trazabilidad</h1>
            </div>
        </header>
<div className="formtitle-container" >
<div className="formicon-container">
<ViticulturaIcon className="formicon" />
</div>
<h1 className="formtitle">{id}</h1>
</div>
<hr className="divider"/>
    <form onSubmit={handleSubmit} className="form">
    {AVISO_BLOQUEADOS[coleccion] && (
    <p style={{ fontFamily: 'Effra', fontSize: '13px', color: '#e65c5c', margin: '0 0 10px' }}>
    {AVISO_BLOQUEADOS[coleccion]}
    </p>
    )}

    <div className="columns-container">
    <div className="column">
    <div className="input-group">
<Listbox
  value={formData.pertenencia}
  onChange={(value) => handlePertenenciaChange({ target: { value } })}
  disabled
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.pertenencia ? "selected" : "placeholder"
        }`}
      >
        {formData.pertenencia
          ? formData.pertenencia.charAt(0).toUpperCase() + formData.pertenencia.slice(1)
          : "Tipo de propiedad"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>

      <ListboxOptions className="custom-listbox-options">
        {["propia", "tercero"].map((option) => (
          <ListboxOption
            key={option}
            value={option}
            className="custom-listbox-option"
          >
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

    </div>
    {}
    {formData.pertenencia === "propia" && (
        <div className="input-group">
        <Listbox
            value={formData.provenienza}
            onChange={(value) =>
            handleChange({ target: { name: "provenienza", value } })
            }
            disabled
        >
            {({ open }) => (
            <>
                <ListboxButton
                className={`custom-listbox-button ${open ? "open" : ""} ${
                    formData.provenienza
                    ? "selected"
                    : "placeholder"
                }`}
                >
                {provenienzaOptions.find(
                    (opt) =>
                    opt.value === formData.provenienza
                )?.label || "Área de cosecha"}
                <span className="custom-arrow-container">
                    <span className="custom-arrow"></span>
                </span>
                </ListboxButton>
                <ListboxOptions className="custom-listbox-options">
                {provenienzaOptions.map((option) => (
                    <ListboxOption
                    key={option.value}
                    value={option.value}
                    className="custom-listbox-option"
                    >
                    {option.label}
                    </ListboxOption>
                ))}
                </ListboxOptions>
            </>
            )}
        </Listbox>
        </div>
    )}
    {}
    {formData.pertenencia === "tercero" && (
        <div className="input-group">
        <input
            type="text"
            name="nombre_finca"
            value={formData.nombre_finca || ""}
            onChange={handleChange}
            className="input"
            placeholder="Nombre de la finca"
        />
        </div>
    )}
    {}
    <div className="input-group">
        <Listbox
        value={formData.tipo_suelo}
        onChange={(value) =>
            handleChange({ target: { name: "tipo_suelo", value } })
        }
        >
        {({ open }) => (
            <>
            <ListboxButton
                className={`custom-listbox-button ${open ? "open" : ""} ${
                formData.tipo_suelo ? "selected" : "placeholder"
                }`}
            >
                {formData.tipo_suelo || "Tipo de suelo"}
                <span className="custom-arrow-container">
                <span className="custom-arrow"></span>
                </span>
            </ListboxButton>
            <ListboxOptions className="custom-listbox-options">
                {tiposDeSuelo.map((suelo) => (
                <ListboxOption
                    key={suelo}
                    value={suelo}
                    className="custom-listbox-option"
                >
                    {suelo}
                </ListboxOption>
                ))}
            </ListboxOptions>
            </>
        )}
        </Listbox>
    </div>
    {}
    <div className="input-group">
        <Listbox
        value={formData.tipo_riego}
        onChange={(value) =>
            handleChange({ target: { name: "tipo_riego", value } })
        }
        >
        {({ open }) => (
            <>
            <ListboxButton
                className={`custom-listbox-button ${open ? "open" : ""} ${
                formData.tipo_riego ? "selected" : "placeholder"
                }`}
            >
                {formData.tipo_riego || "Tipo de riego"}
                <span className="custom-arrow-container">
                <span className="custom-arrow"></span>
                </span>
            </ListboxButton>
            <ListboxOptions className="custom-listbox-options">
                {tiposDeRiego.map((riego) => (
                <ListboxOption
                    key={riego}
                    value={riego}
                    className="custom-listbox-option"
                >
                    {riego}
                </ListboxOption>
                ))}
            </ListboxOptions>
            </>
        )}
        </Listbox>
    </div>
    {}
    <div className="input-group number">
<input
type="number"
name="altura_snm"
title="Altura sobre el nivel del mar"
value={formData.altura_snm || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    altura_snm: value === "" ? null : parseFloat(value),
});
}}
placeholder="Altura sobre el nivel del mar"
/><span className="unit">m</span>
    </div>
    </div>
    
        <div className="column">

    <div className="input-group">
        <Listbox
        value={formData.variedad_uva}
        onChange={(value) =>
            handleChange({ target: { name: "variedad_uva", value } })
        }
        disabled
        >
        {({ open }) => (
            <>
            <ListboxButton
                className={`custom-listbox-button ${open ? "open" : ""} ${
                formData.variedad_uva ? "selected" : "placeholder"
                }`}
            >
                {formData.variedad_uva || "Tipo de suelo"}
                <span className="custom-arrow-container">
                <span className="custom-arrow"></span>
                </span>
            </ListboxButton>
            <ListboxOptions className="custom-listbox-options">
                {variedadesDeUva.map((suelo) => (
                <ListboxOption
                    key={suelo}
                    value={suelo}
                    className="custom-listbox-option"
                >
                    {suelo}
                </ListboxOption>
                ))}
            </ListboxOptions>
            </>
        )}
        </Listbox>
    </div>

<div className="input-group">
<label className="date-label">Fecha de poda de invierno</label>
<FechaDateInput
name="fecha_primera_poda"
value={formData.fecha_primera_poda || ""}
onChange={(iso) =>
    setFormData({
    ...formData,
    fecha_primera_poda: iso || null,
    })
}
className="input"
placeholder="Fecha Primera Poda"
/>
</div>

<div className="input-group">
<label className="date-label">Fecha de poda de verano</label>
<FechaDateInput
name="fecha_segunda_poda"
value={formData.fecha_segunda_poda || ""}
onChange={(iso) =>
    setFormData({
    ...formData,
    fecha_segunda_poda: iso || null,
    })
}
className="input"
placeholder="Fecha segunda Poda"
/>
</div>

<div className="input-group">
<label className="date-label">Fecha de cosecha</label>
<FechaDateInput
name="fecha_cosecha"
value={formData.fecha_cosecha || ""}
onChange={(iso) =>
    setFormData({
    ...formData,
    fecha_cosecha: iso || null,
    })
}
className="input"
placeholder="Fecha cosecha"
    disabled
    />
</div>

    <div className="input-group number">
<input
type="number"
title="Nivel de acidéz"
name="nivel_acido"
value={formData.nivel_acido || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    nivel_acido: value === "" ? null : parseFloat(value),
});
}}
placeholder="Nivel de acidéz"
/><span className="unit">g/L</span>
    </div>

            <div className="input-group number">
<input
type="number"
title="Nivel de azúcar"
name="nivel_azucar"
value={formData.nivel_azucar || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    nivel_azucar: value === "" ? null : parseFloat(value),
});
}}
placeholder="Nivel de azúcar"
/><span className="unit">° Brix</span>
    </div>

            <div className="input-group number">
<input
type="number"
title="Nivel de pH"
name="nivel_ph"
value={formData.nivel_ph || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    nivel_ph: value === "" ? null : parseFloat(value),
});
}}
placeholder="Nivel de pH"
/><span className="unit">pH</span>
    </div>

            <div className="input-group number">
<input
type="number"
title="Quintales"
name="quintales"
value={formData.quintales || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    quintales: value === "" ? null : parseFloat(value),
});
}}
placeholder="Quintales"
    disabled
    /><span className="unit">q</span>
    </div>

    </div>

        <div className="column-last">
                            <div className="input-group number">
<input
type="number"
title="Cantidad de días de sol"
name="dias_sol"
value={formData.dias_sol || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    dias_sol: value === "" ? null : parseFloat(value),
});
}}
placeholder="Cantidad de días de sol"
/><span className="unit">d</span>
    </div>

            <div className="input-group number">
<input
type="number"
title="Precipitación media anual"
name="precipitacion_media_anual"
value={formData.precipitacion_media_anual || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    precipitacion_media_anual: value === "" ? null : parseFloat(value),
});
}}
placeholder="Precipitación media anual"
/><span className="unit">%</span>
    </div>

            <div className="input-group number">
<input
type="number"
title="Temperatura media anual"
name="temperatura_media_anual"
value={formData.temperatura_media_anual || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    temperatura_media_anual: value === "" ? null : parseFloat(value),
});
}}
placeholder="Temperatura media anual"
/><span className="unit">°C</span>
    </div>

            <div className="input-group number">
<input
type="number"
name="humedad_media_anual"
title="Humedad media anual"
value={formData.humedad_media_anual || ""}
className="input"
onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    humedad_media_anual: value === "" ? null : parseFloat(value),
});
}}
placeholder="Humedad media anual"
/><span className="unit">%</span>

    </div>
    
<div className="button-container" style={{width: '370px'}}>
<div className="input-group number">
  
  <input
    type="number"
    title="precio unitario"
    name="precioUnitario"
    value={formData.precioUnidad || ""}
    onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    precioUnidad: value === "" ? null : parseFloat(value),
});
}}
    className="input"
    placeholder="Precio unitario"
  /><span className="unit">$</span>
</div>
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
  type="submit"
  className={`button ${message?.type === 'success' ? 'success' : ''}`}
  style={{ width: '170px' }}
  disabled={isLoading}
>
  <span className="button-text">
    {message?.type === 'success' ? 'Guardado' : isLoading ? 'Guardando...' : 'Guardar cambios'}
  </span>
  {isLoading && (
    <span
      className="progress-bar"
      style={{ width: `${progress}%` }}
    ></span>
  )}
</button>
{message?.type === 'error' && (
  <p className="form-error-message">{message.text}</p>
)}

</div>
    

    </div>
    </div>
    </form>
</div>
    );

    case "embotellado":
    return (
    <div className="Trazabilidad">
        <header className="trazabilidad-header">
            <div className="header-content">
                <h1>Trazabilidad</h1>
            </div>
        </header>
<div className="formtitle-container" >
<div className="formicon-container">
<EmbotelladoIcon className="formicon" />
</div>
<h1 className="formtitle">{id}</h1>
</div>
<hr className="divider"/>
<form onSubmit={handleSubmit}>
{AVISO_BLOQUEADOS[coleccion] && (
<p style={{ fontFamily: 'Effra', fontSize: '13px', color: '#e65c5c', margin: '0 0 10px' }}>
{AVISO_BLOQUEADOS[coleccion]}
</p>
)}
        <div className="columns-container">
    <div className="column">
<div className="input-group"><input
    className="input"
    style={{textTransform:'capitalize', cursor:'default'}}
    title="Tipo de propiedad"
    placeholder="Tipo de propiedad"
    value={formData?.pertenencia || ""}
    disabled 
/></div>

{(formData?.partidas_usadas || []).map((partida, index) => (
<>

{/* Selector de partida */}
<div className="input-group"><input
    className="input"
    title="Partida utilizada"
    style={{cursor:'default'}}
    placeholder="Partida utilizada"
    value={partida.ref || ""}
    disabled 
/></div>

<div className="input-group number"><input
    className="input"
    title="Cantidad de hectolitros"
    style={{cursor:'default'}}
    placeholder="Hectolitros"
    value={partida.cantidad_hl ? (unidadVolumen === 'Litros' ? partida.cantidad_hl * 100 : partida.cantidad_hl) : ""}
    disabled
/>
<span className="unit">{unidadVolumen === 'Litros' ? 'lts' : 'hl'}</span></div>
</>
))}
{(formData?.partidas_usadas || []).length > 0 && (
<div className="input-group">
<Listbox value={unidadVolumen} onChange={setUnidadVolumen}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} selected`}>
{unidadVolumen}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{['Hectolitros', 'Litros'].map((opcion) => (
<ListboxOption key={opcion} value={opcion} className="custom-listbox-option">
{opcion}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
)}




    </div>

        <div className="column">
{(formData?.embotellados_detalle || []).map((detalle, index) => (
<>
    <div className="input-group">
    <input
    type="text"
    className="input"
    placeholder="Forma de botella"
    value={detalle.forma_botella || ""}
    onChange={(e) => {
    const nuevosDetalles = [...formData.embotellados_detalle];
    nuevosDetalles[index].forma_botella = e.target.value;
    setFormData({ ...formData, embotellados_detalle: nuevosDetalles });
    }}
    />
    </div>


    <Listbox
    value={detalle.medida_botella}
    onChange={(value) => {
    const nuevosDetalles = [...formData.embotellados_detalle];
    nuevosDetalles[index].medida_botella = value;
    setFormData({ ...formData, embotellados_detalle: nuevosDetalles });
    }}
>
    {({ open }) => (
    <>
        <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
            detalle.medida_botella ? "selected" : "placeholder"
        }`}
        >
        {detalle.medida_botella || "Medida de botella"}
        <span className="custom-arrow-container">
            <span className="custom-arrow"></span>
        </span>
        </ListboxButton>
        <ListboxOptions className="custom-listbox-options">
        {tiposDeMedida.map((medida) => (
            <ListboxOption
            key={medida}
            value={medida}
            className="custom-listbox-option"
            >
            {medida}
            </ListboxOption>
        ))}
        </ListboxOptions>
    </>
    )}
</Listbox>



    <div className="input-group">
    <input
    type="text"
    className="input"
    placeholder="Tapón"
    value={detalle.tipo_corcho || ""}
    onChange={(e) => {
    const nuevosDetalles = [...formData.embotellados_detalle];
    nuevosDetalles[index].tipo_corcho = e.target.value;
    setFormData({ ...formData, embotellados_detalle: nuevosDetalles });
    }}
    />
    </div>
<div className="input-group">
    <input
    type="number"
    title="Cantidad de botellas"
    className="input"
    placeholder="Cantidad de botellas"
    value={detalle.cantidad_botellas || ""}
    onChange={(e) => {
    const value = e.target.value;
    const nuevosDetalles = [...formData.embotellados_detalle];
    nuevosDetalles[index].cantidad_botellas = value === "" ? null : parseInt(value);
    setFormData({ ...formData, embotellados_detalle: nuevosDetalles });
    }}
/></div>

</>
))}
{/* Vino comprado no tiene cosecha de dónde sacar el año, así que se carga
    a mano acá. Sólo aplica cuando todas las partidas son compradas (si hay
    aunque sea una propia, el año sale de su viticultura y esto no se toca). */}
{(formData?.partidas_usadas || []).length > 0 &&
formData.partidas_usadas.every(p => (p.origen || 'vinificacion') === 'stock') && (
<div className="input-group">
<input
type="number"
className="input"
placeholder="Año del vino"
value={formData.anada || ''}
onChange={(e) => setFormData({ ...formData, anada: e.target.value })}
min="1900"
max="2100"
/>
</div>
)}
        </div>

        <div className="column">
        <label className="input-label">Estiba</label>


<div className="input-group">
<label className="date-label">Fecha de embotellado</label>
<FechaDateInput
name="estiba_inicio"
value={formData.estiba_inicio || ""}
onChange={(iso) =>
    setFormData({
    ...formData,
    estiba_inicio: iso || null,
    })
}
className="input"
placeholder="Fecha de embotellado"
/>
</div>

<div className="input-group">
<label className="date-label">Fecha de salida al mercado</label>
<FechaDateInput
name="estiba_final"
value={formData.estiba_final || ""}
onChange={(iso) =>
    setFormData({
    ...formData,
    estiba_final: iso || null,
    })
}
className="input"
placeholder="Fecha de embotellado"
/>
</div>
<div className="button-container" style={{width: '370px'}}>
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
  type="submit"
  className={`button ${message?.type === 'success' ? 'success' : ''}`}
  style={{ width: '170px' }}
  disabled={isLoading}
>
  <span className="button-text">
    {message?.type === 'success' ? 'Guardado' : isLoading ? 'Guardando...' : 'Guardar cambios'}
  </span>
  {isLoading && (
    <span
      className="progress-bar"
      style={{ width: `${progress}%` }}
    ></span>
  )}
</button>
{message?.type === 'error' && (
  <p className="form-error-message">{message.text}</p>
)}

</div>
        </div>
    </div>
</form>
</div>
    );

    case "vinificacion":
    return (
    <div className="Trazabilidad">
        <header className="trazabilidad-header">
            <div className="header-content">
                <h1>Trazabilidad</h1>
            </div>
        </header>
<div className="formtitle-container" >
<div className="formicon-container">
<VinificacionIcon className="formicon" />
</div>
<h1 className="formtitle">{id}</h1>
</div>
<hr className="divider"/>
<form onSubmit={handleSubmit}>
{AVISO_BLOQUEADOS[coleccion] && (
<p style={{ fontFamily: 'Effra', fontSize: '13px', color: '#e65c5c', margin: '0 0 10px' }}>
{AVISO_BLOQUEADOS[coleccion]}
</p>
)}
        <div className="columns-container">
    <div className="column long">
<label className="input-label">Primera fermentación</label>
<div className="input-group">
  <label className="date-label">Fecha de inicio</label>
  <FechaDateInput
    name="fecha_primaria_inicio"
    value={formData.fermentacion_primaria?.inicio || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          inicio: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de inicio"
  />
</div>

<div className="input-group number">
  <input
    type="number"
    title="Temperatura"
    name="Temperatura"
    value={formData.fermentacion_primaria?.temperatura || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          temperatura: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Temperatura"
  /><span className="unit">°C</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Humedad"
    name="humedad"
    value={formData.fermentacion_primaria?.humedad || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          humedad: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Humedad"
  /><span className="unit">%</span>
</div>

<div className="input-group">
  <Listbox
    value={formData.tipo_levadura || ""}
    onChange={(value) =>
      setFormData({
        ...formData,
        tipo_levadura: value,
      })
    }
  >
    {({ open }) => (
      <>
        <ListboxButton
          className={`custom-listbox-button ${open ? "open" : ""} ${
            formData.tipo_levadura ? "selected" : "placeholder"
          }`}
        >
          {formData.tipo_levadura || "Tipo de levadura"}
          <span className="custom-arrow-container">
            <span className="custom-arrow"></span>
          </span>
        </ListboxButton>

        <ListboxOptions className="custom-listbox-options">
          {/* Fermentación Nativa */}
          <div className="listbox-group-label">Fermentación Nativa</div>
          <ListboxOption
            value={levaduraOptions["Fermentación Nativa"]}
            className="custom-listbox-option"
          >
            {levaduraOptions["Fermentación Nativa"]}
          </ListboxOption>

          {/* Saccharomyces */}
          <div className="listbox-group-label">Levaduras Saccharomyces</div>
          {levaduraOptions["Saccharomyces"].map((levadura, index) => (
            <ListboxOption
              key={`sacch-${index}`}
              value={levadura}
              className="custom-listbox-option"
            >
              {levadura}
            </ListboxOption>
          ))}

          {/* No-Saccharomyces */}
          <div className="listbox-group-label">Levaduras No-Saccharomyces</div>
          {levaduraOptions["No-Saccharomyces"].map((levadura, index) => (
            <ListboxOption
              key={`no-sacch-${index}`}
              value={levadura}
              className="custom-listbox-option"
            >
              {levadura}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </>
    )}
  </Listbox>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Graduación alcohólica"
    name="Graduación alcohólica"
    value={formData.fermentacion_primaria?.graduacion_alcoholica || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          graduacion_alcoholica: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Graduación alcohólica"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de acidéz"
    name="Nivel de acidéz"
    value={formData.fermentacion_primaria?.nivel_acidez || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          nivel_acidez: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de acidéz"
  /><span className="unit">g/L</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de azúcar"
    name="Nivel de azúcar"
    value={formData.fermentacion_primaria?.nivel_azucar || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          nivel_azucar: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de azúcar"
  /><span className="unit">° Brix</span>
</div>


<div className="input-group number">
  <input
    type="number"
    title="Nivel de pH"
    name="Nivel de pH"
    value={formData.fermentacion_primaria?.nivel_ph || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          nivel_ph: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de pH"
  /><span className="unit">pH</span>
</div>

<div className="input-group">
<Listbox
  value={formData.fermentacion_primaria?.recipiente_utilizado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_primaria: {
        ...formData.fermentacion_primaria,
        recipiente_utilizado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_primaria?.recipiente_utilizado ? "selected" : "placeholder"
        }`}
      >
        {formData.fermentacion_primaria?.recipiente_utilizado || "Tipo de recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {tiposDeRecipienteFermentacion.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
{formData.fermentacion_primaria?.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
  <>
<div className="input-group">
    <Listbox
  value={formData.fermentacion_primaria?.recipiente_uso || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_primaria: {
        ...formData.fermentacion_primaria,
        recipiente_uso: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_primaria?.recipiente_uso ? "selected" : "placeholder"
        }`}
        
      >
        {formData.fermentacion_primaria?.recipiente_uso || "Uso del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteUso.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>

<div className="input-group">
<Listbox
  value={formData.fermentacion_primaria?.recipiente_tostado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_primaria: {
        ...formData.fermentacion_primaria,
        recipiente_tostado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_primaria?.recipiente_tostado ? "selected" : "placeholder"
        }`}
        
      >
        {formData.fermentacion_primaria?.recipiente_tostado || "Tostado del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteTostado.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>
</>)}

<div className="input-group">
  <label className="date-label">Fecha de finalización</label>
  <FechaDateInput
    name="fecha_primaria_fin"
    value={formData.fermentacion_primaria?.fin || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        fermentacion_primaria: {
          ...formData.fermentacion_primaria,
          fin: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de finalización"
  />
</div>


<label className="input-label" style={{marginTop: '15px'}}>Segunda fermentación</label>
<div className="input-group">
  <label className="date-label">Fecha de inicio</label>
  <FechaDateInput
    name="fecha_secundaria_inicio"
    value={formData.fermentacion_secundaria?.inicio || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          inicio: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de inicio"
  />
</div>

<div className="input-group number">
  <input
    type="number"
    title="Temperatura"
    name="Temperatura"
    value={formData.fermentacion_secundaria?.temperatura || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          temperatura: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Temperatura"
/><span className="unit">°C</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Humedad"
    name="humedad"
    value={formData.fermentacion_secundaria?.humedad || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          humedad: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Humedad"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Graduación alcohólica"
    name="Graduación alcohólica"
    value={formData.fermentacion_secundaria?.graduacion_alcoholica || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          graduacion_alcoholica: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Graduación alcohólica"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de acidéz"
    name="Nivel de acidéz"
    value={formData.fermentacion_secundaria?.nivel_acidez || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          nivel_acidez: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de acidéz"
  /><span className="unit">g/L</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de azúcar"
    name="Nivel de azúcar"
    value={formData.fermentacion_secundaria?.nivel_azucar || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          nivel_azucar: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de azúcar"
  />
</div>


<div className="input-group number">
  <input
    type="number"
    title="Nivel de pH"
    name="Nivel de pH"
    value={formData.fermentacion_secundaria?.nivel_ph || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          nivel_ph: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de pH"
  /><span className="unit">pH</span>
</div>

<div className="input-group">
<Listbox
  value={formData.fermentacion_secundaria?.recipiente_utilizado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_secundaria: {
        ...formData.fermentacion_secundaria,
        recipiente_utilizado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_secundaria?.recipiente_utilizado ? "selected" : "placeholder"
        }`}
      >
        {formData.fermentacion_secundaria?.recipiente_utilizado || "Tipo de recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {tiposDeRecipienteFermentacion.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
{formData.fermentacion_secundaria?.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
  <>
<div className="input-group">
    <Listbox
  value={formData.fermentacion_secundaria?.recipiente_uso || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_secundaria: {
        ...formData.fermentacion_secundaria,
        recipiente_uso: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_secundaria?.recipiente_uso ? "selected" : "placeholder"
        }`}
        
      >
        {formData.fermentacion_secundaria?.recipiente_uso || "Uso del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteUso.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>

<div className="input-group">
<Listbox
  value={formData.fermentacion_secundaria?.recipiente_tostado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      fermentacion_secundaria: {
        ...formData.fermentacion_secundaria,
        recipiente_tostado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.fermentacion_secundaria?.recipiente_tostado ? "selected" : "placeholder"
        }`}
        
      >
        {formData.fermentacion_secundaria?.recipiente_tostado || "Tostado del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteTostado.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>
</>)}
<div className="input-group">
  <label className="date-label">Fecha de finalización</label>
  <FechaDateInput
    name="fecha_secundaria_fin"
    value={formData.fermentacion_secundaria?.fin || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        fermentacion_secundaria: {
          ...formData.fermentacion_secundaria,
          fin: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de finalización"
  />
</div>
    </div>

<div className="column long">
    
<label className="input-label">Tranquilización y filtrado</label>
<div className="input-group">
  <label className="date-label">Fecha de inicio</label>
  <FechaDateInput
    name="fecha_tranquilizacion_inicio"
    value={formData.tranquilizacion?.inicio || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          inicio: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de inicio"
  />
</div>

<div className="input-group number">
  <input
    type="number"
    title="Temperatura"
    name="Temperatura"
    value={formData.tranquilizacion?.temperatura || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          temperatura: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Temperatura"
  /><span className="unit">°C</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Humedad"
    name="humedad"
    value={formData.tranquilizacion?.humedad || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          humedad: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Humedad"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Graduación alcohólica"
    name="Graduación alcohólica"
    value={formData.tranquilizacion?.graduacion_alcoholica || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          graduacion_alcoholica: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Graduación alcohólica"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de acidéz"
    name="Nivel de acidéz"
    value={formData.tranquilizacion?.nivel_acidez || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          nivel_acidez: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de acidéz"
  /><span className="unit">g/L</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de azúcar"
    name="Nivel de azúcar"
    value={formData.tranquilizacion?.nivel_azucar || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          nivel_azucar: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de azúcar"
  /><span className="unit">° Brix</span>
</div>


<div className="input-group number">
  <input
    type="number"
    title="Nivel de pH"
    name="Nivel de pH"
    value={formData.tranquilizacion?.nivel_ph || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          nivel_ph: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de pH"
  /><span className="unit">pH</span>
</div>

<div className="input-group">
<Listbox
  value={formData.tranquilizacion?.recipiente_utilizado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      tranquilizacion: {
        ...formData.tranquilizacion,
        recipiente_utilizado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.tranquilizacion?.recipiente_utilizado ? "selected" : "placeholder"
        }`}
      >
        {formData.tranquilizacion?.recipiente_utilizado || "Tipo de recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {tiposDeRecipienteFermentacion.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
{formData.tranquilizacion?.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
  <>
<div className="input-group">
    <Listbox
  value={formData.tranquilizacion?.recipiente_uso || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      tranquilizacion: {
        ...formData.tranquilizacion,
        recipiente_uso: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.tranquilizacion?.recipiente_uso ? "selected" : "placeholder"
        }`}
        
      >
        {formData.tranquilizacion?.recipiente_uso || "Uso del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteUso.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>

<div className="input-group">
<Listbox
  value={formData.tranquilizacion?.recipiente_tostado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      tranquilizacion: {
        ...formData.tranquilizacion,
        recipiente_tostado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.tranquilizacion?.recipiente_tostado ? "selected" : "placeholder"
        }`}
        
      >
        {formData.tranquilizacion?.recipiente_tostado || "Tostado del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteTostado.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div></>)}

<div className="input-group">
  <label className="date-label">Fecha de finalización</label>
  <FechaDateInput
    name="fecha_tranquilizacion_fin"
    value={formData.tranquilizacion?.fin || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        tranquilizacion: {
          ...formData.tranquilizacion,
          fin: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de finalización"
  />
</div>
</div>

<div className="column long">
    
<label className="input-label">Guarda</label>
<div className="input-group">
  <label className="date-label">Fecha de inicio</label>
  <FechaDateInput
    name="fecha_guarda_inicio"
    value={formData.guarda?.inicio || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          inicio: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de inicio"
  />
</div>

<div className="input-group number">
  <input
    type="number"
    title="Temperatura"
    name="Temperatura"
    value={formData.guarda?.temperatura || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          temperatura: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Temperatura"
  /><span className="unit">°C</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Humedad"
    name="humedad"
    value={formData.guarda?.humedad || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          humedad: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Humedad"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Graduación alcohólica"
    name="Graduación alcohólica"
    value={formData.guarda?.graduacion_alcoholica || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          graduacion_alcoholica: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Graduación alcohólica"
  /><span className="unit">%</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de acidéz"
    name="Nivel de acidéz"
    value={formData.guarda?.nivel_acidez || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          nivel_acidez: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de acidéz"
  /><span className="unit">g/L</span>
</div>

<div className="input-group number">
  <input
    type="number"
    title="Nivel de azúcar"
    name="Nivel de azúcar"
    value={formData.guarda?.nivel_azucar || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          nivel_azucar: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de azúcar"
  /><span className="unit">° Brix</span>
</div>


<div className="input-group number">
  <input
    type="number"
    title="Nivel de pH"
    name="Nivel de pH"
    value={formData.guarda?.nivel_ph || ""}
    onChange={(e) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          nivel_ph: e.target.value || null,
        },
      })
    }
    className="input"
    placeholder="Nivel de pH"
  /><span className="unit">pH</span>
</div>

<div className="input-group">
<Listbox
  value={formData.guarda?.recipiente_utilizado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      guarda: {
        ...formData.guarda,
        recipiente_utilizado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.guarda?.recipiente_utilizado ? "selected" : "placeholder"
        }`}
      >
        {formData.guarda?.recipiente_utilizado || "Tipo de recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {tiposDeRecipienteFermentacion.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>
</div>
{formData.guarda?.recipiente_utilizado?.toLowerCase().startsWith("barrica") && (
  <>
<div className="input-group">
    <Listbox
  value={formData.guarda?.recipiente_uso || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      guarda: {
        ...formData.guarda,
        recipiente_uso: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.guarda?.recipiente_uso ? "selected" : "placeholder"
        }`}
        
      >
        {formData.guarda?.recipiente_uso || "Uso del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteUso.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div>

<div className="input-group">
<Listbox
  value={formData.guarda?.recipiente_tostado || ""}
  onChange={(value) =>
    setFormData({
      ...formData,
      guarda: {
        ...formData.guarda,
        recipiente_tostado: value,
      },
    })
  }
>
  {({ open }) => (
    <>
      <ListboxButton
        className={`custom-listbox-button ${open ? "open" : ""} ${
          formData.guarda?.recipiente_tostado ? "selected" : "placeholder"
        }`}
        
      >
        {formData.guarda?.recipiente_tostado || "Tostado del recipiente"}
        <span className="custom-arrow-container">
          <span className="custom-arrow"></span>
        </span>
      </ListboxButton>
      <ListboxOptions className="custom-listbox-options">
        {opcionesRecipienteTostado.map((option) => (
          <ListboxOption key={option} value={option} className="custom-listbox-option">
            {option.charAt(0).toUpperCase() + option.slice(1)}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </>
  )}
</Listbox>

</div></>)}
<label className="date-label">Precio unitario</label>
<div className="input-group number">
  
  <input
    type="number"
    title="precio unitario"
    name="precioUnitario"
    value={formData.precioUnidad || ""}
    onChange={(e) => {
const value = e.target.value;
setFormData({
    ...formData,
    precioUnidad: value === "" ? null : parseFloat(value),
});
}}
    className="input"
    placeholder="Precio unitario"
  /><span className="unit">$</span>
</div>
<div className="input-group">
  <label className="date-label">Fecha de finalización</label>
  <FechaDateInput
    name="fecha_guarda_fin"
    value={formData.guarda?.fin || ""}
    onChange={(iso) =>
      setFormData({
        ...formData,
        guarda: {
          ...formData.guarda,
          fin: iso || null,
        },
      })
    }
    className="input"
    placeholder="Fecha de finalización"
  />
</div>
<div className="button-container">
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
  type="submit"
  className={`button ${message?.type === 'success' ? 'success' : ''}`}
  style={{ width: '170px' }}
  disabled={isLoading}
>
  <span className="button-text">
    {message?.type === 'success' ? 'Guardado' : isLoading ? 'Guardando...' : 'Guardar cambios'}
  </span>
  {isLoading && (
    <span
      className="progress-bar"
      style={{ width: `${progress}%` }}
    ></span>
  )}
</button>
{message?.type === 'error' && (
  <p className="form-error-message">{message.text}</p>
)}

</div></div>
    </div>
</form>
</div>
    );
    
    default:
    return <p>No hay formulario definido para esta colección</p>;
}
};

return <div className="doc-edit">{renderForm()}</div>;
}